
import { SetupContext } from "vue";

import { BaseButton, BaseText } from "components/atoms";
import { InputField } from "components/molecules";
import { useLoginForm } from "composables/useLoginForm";

import { iconN } from "assets/icons";

export default {
  name: "LoginForm",
  components: { BaseButton, InputField, BaseText },
  setup(props: {}, { emit }: SetupContext) {
    const { userEmail, userPassword, v, handleBlur } = useLoginForm();

    const handleOnSubmit = () => {
      v.value.$touch();

      if (!v.value.userEmail.$error && !v.value.userPassword.$error) {
        emit("on-login-submit", {
          username: userEmail.value,
          password: userPassword.value,
        });
        return;
      }
      console.log("Rejected");
    };

    return {
      userEmail,
      userPassword,
      v,
      handleBlur,
      handleOnSubmit,
      userIcon: iconN.USER,
      lockIcon: iconN.LOCK,
    };
  },
  emits: ["on-login-submit"],
};
